import { cn } from "@landing/lib/utils"
import { Loader2 } from "lucide-react"

interface LoadingProps {
  className?: string
  spinnerClassName?: string
}

export function Loading({ className, spinnerClassName }: LoadingProps) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 bg-transparent flex items-center justify-center overflow-hidden",
        className,
      )}
    >
      <Loader2 className={cn("size-6 animate-spin-fast text-blue-primary", spinnerClassName)} />
    </div>
  )
}
